const blockJobSearch = async($block) => {
	const JobSearchModule = await import( '../classes/job-search' );
	const JobSearch = JobSearchModule.default;
	const CustomSelectLabelsModule = await import('../modules/custom-select-labels');
	const CustomSelectLabels = CustomSelectLabelsModule.default;

	CustomSelectLabels($block);
	new JobSearch($block);
};

themeUtils.loadBlock( blockJobSearch, 'job-search', '.section-job-search' );
